import { useTranslation } from "react-i18next";

import type { Prettify } from "@/types";
import { useFetchMe } from "@/user/services";

import { type Conversation } from "../../types";
import MessengerCard from "../base/MessengerCard";
import ConversationImage from "./ConversationImage";

export default function ConversationCard({
  conversation,
  onClick,
  isActive,
}: {
  conversation: Prettify<Conversation<true, true, true>>;
  onClick: () => void;
  isActive?: boolean;
}) {
  const { t } = useTranslation("messenger.user");
  const { data: currentUser } = useFetchMe();

  const lastMessage = conversation.last_messages?.[0];

  const lastMessageText = !lastMessage
    ? t("No messages yet")
    : lastMessage.type === "voice"
      ? t("Voice message")
      : lastMessage.file
        ? lastMessage.file.file_name
        : lastMessage.content;

  const isLastMessageMine =
    currentUser && lastMessage?.user_id === currentUser.id;

  const isRead = isLastMessageMine
    ? conversation.type === "group" ||
      !!(
        conversation.last_outgoing_read_message_id &&
        lastMessage!.id <= conversation.last_outgoing_read_message_id
      )
    : undefined;

  const title =
    conversation.type === "private"
      ? conversation.user.first_name + " " + conversation.user.last_name
      : (conversation.group?.name ?? t("Deleted group"));

  return (
    <MessengerCard
      image={<ConversationImage conversation={conversation} size="lg" />}
      title={title}
      subtitle={lastMessageText}
      isRead={isRead}
      unreadCount={conversation.unread_messages_count}
      isActive={isActive}
      onClick={onClick}
    />
  );
}
